export const CHANGE_LIST_VERSION = 'CHANGE_LIST_VERSION';

export const ADD_SUPPLIER_DATA = 'ADD_SUPPLIER_DATA';

export const EDIT_NEW_PRODUCT = 'EDIT_NEW_PRODUCT';
